export const getContentByLayoutVariant = (content, layoutVariant, placements = ['main', 'content']) => {
  if (content && typeof content === 'object' && !Array.isArray(content)) {
    return placements.reduce((acc, currPlacement) => {
      if (content[currPlacement]) {
        return acc.concat(getContentByLayoutVariant(content[currPlacement], layoutVariant))
      }
      return acc
    }, [])
  }

  if (Array.isArray(content)) {
    return content.reduce((acc, curr) => {
      if (curr.layoutVariant === layoutVariant) {
        acc.push(curr)
        return acc
      }
      if (curr.items) {
        return acc.concat(getContentByLayoutVariant(curr.items, layoutVariant))
      } else if (curr.articleSubElements) {
        return acc.concat(getContentByLayoutVariant(curr.articleSubElements, layoutVariant))
      }
      return acc
    }, [])
  }
  return []
}
